
        <div class="subnav-link">
            <span>
                <ng-content></ng-content>
            </span>
            <span *ngIf="badge" class="badge badge-secondary">
                {{ badge }}
            </span>
        </div>
    